<template>
  <BaseNoticeItem>
    <template #head>
      <strong>FLSA Classification Pending</strong>
    </template>
    <template #body>
      <div>
        Your FLSA classification is being determined by the Worksome team. Once completed, you can
        sign the contract. If you have any questions, please contact us via Chat.
      </div>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
})
</script>
